import { Capability } from '@nexelem/graphne-api';

import { useCustomTranslation } from '../../../../hooks';

type BrigadeCompetenceProps = {
  capabilities?: Capability[];
  className?: string;
};

export const WorkerCapabilities = ({ className, capabilities }: BrigadeCompetenceProps) => {
  const { tWrapper } = useCustomTranslation('products.productionPlan');

  const hasCapabilities = capabilities && capabilities.length > 0;

  return (
    <div className={className}>
      <div className="mb-2 text-t14-sb text-text-secondary-darker">{tWrapper('capabilities')}</div>
      <div className="flex flex-wrap gap-2">
        {hasCapabilities ? (
          <ul className="flex flex-col gap-1 pl-6">
            {capabilities.map((capability) => (
              <li className="text-s16" key={capability.id}>
                {capability.name}
              </li>
            ))}
          </ul>
        ) : (
          <span className="text-s16">-</span>
        )}
      </div>
    </div>
  );
};
